class CartDrawer extends HTMLElement {
  // Reset complet du drawer : listeners, classes, attributs critiques
  resetCartDrawerState(context = '', triggeredBy = null) {
    try {
      const cartDrawerRoot = document.querySelector('cart-drawer');
      const cartDrawerDiv = document.getElementById('CartDrawer');
      if (cartDrawerRoot) cartDrawerRoot.classList.remove('is-empty');
      if (cartDrawerDiv) cartDrawerDiv.classList.remove('is-empty');
      // Nettoyage listeners custom éventuels (à compléter si besoin)
      // Exemple :
      // Array.from(cartDrawerDiv.querySelectorAll('button')).forEach(btn => btn.replaceWith(btn.cloneNode(true)));
      // Nettoyage attributs critiques
      const checkoutBtn = cartDrawerDiv ? cartDrawerDiv.querySelector('#CartDrawer-Checkout') : null;
      if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
      // Log contexte d'ouverture
      console.log(`[cart-drawer.js] [AUDIT] resetCartDrawerState appelé (contexte: ${context}, triggeredBy: ${triggeredBy ? triggeredBy.className : 'aucun'})`);
    } catch (e) {
      console.error('[cart-drawer.js] [AUDIT] resetCartDrawerState erreur:', e);
    }
  }

  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // Fetch du panier à jour avant d’ouvrir le drawer
      fetch('/cart?section_id=cart-drawer&section_id=cart-icon-bubble')
        .then(response => response.text())
        .then((html) => {
          // Parser la réponse pour obtenir les sections à jour
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const parsedState = {
            id: null, // ou l’id du panier si besoin
            sections: {
              'cart-drawer': doc.querySelector('#CartDrawer')?.outerHTML || '',
              'cart-icon-bubble': doc.querySelector('#cart-icon-bubble')?.outerHTML || '',
            }
          };
          this.renderContents(parsedState);
        });
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Audit : reset complet du drawer à chaque ouverture
    if (typeof this.resetCartDrawerState === 'function') {
      this.resetCartDrawerState('open', triggeredBy);
    } else {
      console.warn('[cart-drawer.js] resetCartDrawerState non défini lors de l’ouverture du drawer.');
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        let containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        let focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (!containerToTrapFocusOn) {
          // Fallback : réessayer après un court délai
          setTimeout(() => {
            containerToTrapFocusOn = this.classList.contains('is-empty')
              ? this.querySelector('.drawer__inner-empty')
              : document.getElementById('CartDrawer');
            if (containerToTrapFocusOn) {
              trapFocus(containerToTrapFocusOn, focusElement);
              console.log('[cart-drawer.js] Fallback focus appliqué après délai.');
            } else {
              // Fallback ultime : focus sur le bouton fermer
              focusElement = this.querySelector('.drawer__close');
              if (focusElement) {
                focusElement.focus();
                console.warn('[cart-drawer.js] Focus appliqué sur le bouton fermer (fallback ultime).');
              } else {
                console.error('[cart-drawer.js] Impossible d’appliquer le focus : aucun container ni bouton fermer.');
              }
            }
          }, 50);
        } else {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // LOG DEBUG AUTOMATIQUE : Affiche la réponse AJAX complète dans la console à chaque ajout
    try {
      if (parsedState && parsedState.sections && parsedState.sections['cart-drawer']) {
        console.log('%c[DEBUG AJAX] Réponse cart-drawer :', 'background: #222; color: #bada55; font-weight: bold;');
        console.log(parsedState.sections['cart-drawer']);
      } else {
        console.warn('[DEBUG AJAX] Réponse cart-drawer absente ou incomplète', parsedState);
      }
    } catch(e) {
      console.error('[DEBUG AJAX] Erreur lors du log cart-drawer :', e);
    }
    // DEBUG LOG: Affiche le HTML reçu pour analyse
    console.log('=== DEBUG cart-drawer.js ===');
    console.log('parsedState.sections:', parsedState.sections);
    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      console.log('HTML cart-drawer reçu:', parsedState.sections['cart-drawer']);
      // Vérification rapide de la présence des items
      if (parsedState.sections['cart-drawer'].includes('cart-item')) {
        console.log('Au moins un produit détecté dans le HTML du drawer.');
      } else {
        console.warn('Aucun produit détecté dans le HTML du drawer.');
      }
    } else {
      console.warn('Aucune section cart-drawer reçue dans parsedState.');
    }

    console.log('parsedState.sections:', parsedState.sections);
    // 1. Suppression stricte de la classe 'is-empty' sur <cart-drawer> ET #CartDrawer (sécurité CSS)
    const cartDrawerRoot = this;
    const cartDrawerDiv = document.getElementById('CartDrawer');
    if (cartDrawerRoot.classList.contains('is-empty')) {
      cartDrawerRoot.classList.remove('is-empty');
      console.log('[cart-drawer.js] Classe is-empty retirée sur <cart-drawer>');
    }
    if (cartDrawerDiv && cartDrawerDiv.classList.contains('is-empty')) {
      cartDrawerDiv.classList.remove('is-empty');
      console.log('[cart-drawer.js] Classe is-empty retirée sur #CartDrawer');
    }

    this.productId = parsedState.id;
    const cartDrawerHTML = parsedState.sections['cart-drawer'];
    // 2. Sécurisation du remplacement DOM (vide -> plein)
    if (cartDrawerDiv && cartDrawerHTML) {
      const doc = new DOMParser().parseFromString(cartDrawerHTML, 'text/html');
      const newDrawer = doc.getElementById('CartDrawer');
      if (newDrawer) {
        console.log('=== DEBUG cart-drawer.js === Nouveau DOM injecté :', newDrawer.outerHTML);
        // Correction critique : remplacer tout le composant <cart-drawer-items> lors du premier ajout
        const newCartDrawerItems = newDrawer.querySelector('cart-drawer-items');
        const currentCartDrawerItems = cartDrawerDiv.querySelector('cart-drawer-items');
        let replaced = false;
        if (newCartDrawerItems && currentCartDrawerItems) {
          // Correction : détecter si le nouvel HTML est vide ou plein
          const isNowEmpty = newCartDrawerItems.classList.contains('is-empty') || newCartDrawerItems.querySelector('.drawer__inner-empty');
          currentCartDrawerItems.replaceWith(newCartDrawerItems);
          replaced = true;
          // Sécurité : forcer la définition du custom element après chaque remplacement
          if (!window.customElements.get('cart-drawer-items')) {
            try {
              window.customElements.define('cart-drawer-items', CartDrawerItems);
              console.log('[cart-drawer.js] customElements.define forcé pour <cart-drawer-items>');
            } catch (e) {
              console.warn('[cart-drawer.js] customElements déjà défini (OK)');
            }
          }
          // Relancer explicitement les listeners globaux (Shopify + custom)
          if (typeof window.initAddToCartListeners === 'function') {
            window.initAddToCartListeners();
          }
          if (isNowEmpty) {
            console.log('=== DEBUG cart-drawer.js === <cart-drawer-items> remplacé (transition plein → vide)');
          } else {
            console.log('=== DEBUG cart-drawer.js === <cart-drawer-items> remplacé (transition vide → plein)');
          }
        } else {
          // Sécurisation : fallback sur .drawer__inner comme avant
          const newDrawerInner = newDrawer.querySelector('.drawer__inner');
          const currentDrawerInner = cartDrawerDiv.querySelector('.drawer__inner');
          const currentDrawerInnerEmpty = cartDrawerDiv.querySelector('.drawer__inner-empty');
          // Audit : reset complet du drawer avant remplacement DOM
          if (typeof window.resetCartDrawerState === 'function') {
            window.resetCartDrawerState('replaceDOM');
          } else if (typeof this.resetCartDrawerState === 'function') {
            this.resetCartDrawerState('replaceDOM');
          } else {
            console.warn('[cart-drawer.js] resetCartDrawerState non défini avant remplacement DOM.');
          }
          if (newDrawerInner && currentDrawerInner) {
            console.log('[cart-drawer.js] [AUDIT] Nettoyage listeners drawer rapide AVANT remplacement DOM.');
            currentDrawerInner.replaceWith(newDrawerInner);
            replaced = true;
            console.log('=== DEBUG cart-drawer.js === .drawer__inner remplacé');
          } else if (newDrawerInner && currentDrawerInnerEmpty) {
            currentDrawerInnerEmpty.replaceWith(newDrawerInner);
            replaced = true;
            console.log('=== DEBUG cart-drawer.js === .drawer__inner-empty remplacé');
          }
          // Fallback ultime
          if (!replaced && newDrawerInner) {
            cartDrawerDiv.appendChild(newDrawerInner);
            console.warn('[cart-drawer.js] Fallback : .drawer__inner injecté en appendChild');
          }
        }
        // 3. Sécurité : retirer à nouveau la classe is-empty si elle a été réinjectée par Liquid ou AJAX
        if (cartDrawerRoot.classList.contains('is-empty')) {
          cartDrawerRoot.classList.remove('is-empty');
          console.log('[cart-drawer.js] (après injection) Classe is-empty retirée sur <cart-drawer>');
        }
        if (cartDrawerDiv.classList.contains('is-empty')) {
          cartDrawerDiv.classList.remove('is-empty');
          console.log('[cart-drawer.js] (après injection) Classe is-empty retirée sur #CartDrawer');
        }
        // Correction : suppression du bloc .drawer__inner-empty résiduel UNIQUEMENT si panier non vide
        const drawerInner = cartDrawerDiv ? cartDrawerDiv.querySelector('.drawer__inner') : null;
        if (drawerInner) {
          if (!cartDrawerRoot.classList.contains('is-empty')) {
            const emptyBlock = drawerInner.querySelector('.drawer__inner-empty');
            if (emptyBlock) {
              emptyBlock.remove();
              console.log('[cart-drawer.js] Bloc .drawer__inner-empty supprimé après ajout produit');
            }
          }
        }
        // 4. Relance systématique des listeners JS (Shopify + custom)
        if (typeof window.initAddToCartListeners === 'function') {
          window.initAddToCartListeners();
        }
        // TODO : Ajouter ici d'autres initialisations JS spécifiques si besoin
      } else {
        console.warn('[cart-drawer.js] Fallback critique : #CartDrawer non trouvé dans le nouveau HTML.');
      }
    } else {
      console.warn('[cart-drawer.js] Fallback critique : cartDrawerDiv ou cartDrawerHTML manquant.');
    }
    // 5. Réinitialisation listeners drawer UNIQUEMENT (pas d'appel accessibilité header)
    if (typeof window.initAddToCartListeners === 'function') {
      window.initAddToCartListeners();
    }
    if (typeof this.reconnectListeners === 'function') {
      this.reconnectListeners();
    }
    // Activation ciblée du bouton checkout UNIQUEMENT sur le drawer principal (page produit)
    requestAnimationFrame(() => {
      const cartDrawerDiv = document.getElementById('CartDrawer');
      if (cartDrawerDiv) {
        const hasItems = !!cartDrawerDiv.querySelector('.cart-item');
        const checkoutBtn = cartDrawerDiv.querySelector('#CartDrawer-Checkout');
        if (checkoutBtn) {
          if (hasItems) {
            checkoutBtn.removeAttribute('disabled');
            console.log('[cart-drawer.js] CartDrawer-Checkout activé (panier non vide)');
          } else {
            checkoutBtn.setAttribute('disabled', '');
            console.log('[cart-drawer.js] CartDrawer-Checkout désactivé (panier vide)');
          }
        }
      }
    });
    // Activation ciblée du bouton checkout UNIQUEMENT sur le drawer principal (page produit)
    requestAnimationFrame(() => {
      const cartDrawerDiv = document.getElementById('CartDrawer');
      // Vérifie qu’on est bien sur la page produit (présence d’un formulaire d’ajout au panier natif)
      const isProductPage = !!document.querySelector('form[action^="/cart/add"]');
      if (cartDrawerDiv && isProductPage) {
        const hasItems = !!cartDrawerDiv.querySelector('.cart-item');
        const checkoutBtn = cartDrawerDiv.querySelector('#CartDrawer-Checkout');
        if (checkoutBtn) {
          if (hasItems) {
            checkoutBtn.removeAttribute('disabled');
            console.log('[cart-drawer.js] CartDrawer-Checkout activé (panier non vide)');
          } else {
            checkoutBtn.setAttribute('disabled', '');
            console.log('[cart-drawer.js] CartDrawer-Checkout désactivé (panier vide)');
          }
        }
      }
    });
    // Ouverture du drawer APRES injection DOM + listeners (séquence critique)
    this.open();
  };


  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  };

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  setActiveElement(element) {
    this.activeElement = element;
  };
}

customElements.define('cart-drawer', CartDrawer);

// S'assurer que CartItems est bien défini ailleurs dans le projet
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
